import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserNavbar from "../../components/UserNavbar";
import { getProducts } from "./api/products";
import { addToCart } from "./api/cart";

export default function ProductList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [addingIds, setAddingIds] = useState({});
  const [cartQuantities, setCartQuantities] = useState({});
  const [cartLineIds, setCartLineIds] = useState({});
  const [cartError, setCartError] = useState("");
  const subcategoryName = searchParams.get("subcategory") || "Products";
    const loadProducts = async () => {
    const subcategoryId = searchParams.get("subcategoryId");
    const response = await getProducts(subcategoryId);
    const data = Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response?.data?.products)
      ? response.data.products
      : Array.isArray(response?.products)
      ? response.products
      : [];
    console.log(data)
    setProducts(data);
  };

  const loadCartQuantities = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token || token === "null" || token === "undefined") {
      setCartQuantities({});
      return;
    }

    try {
      const { data } = await axios.get("https://www.frendrops.in/api/basket", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const payload = data?.data ?? data ?? {};
      const rows = Array.isArray(payload.orderToBePlaced) ? payload.orderToBePlaced : [];
      const next = {};
      const nextLineIds = {};

      rows.forEach((row) => {
        if (row?.is_order_placed === true) return;
        const productId =
          row?.product_id?._id ||
          row?.product_id?.id ||
          row?.product_id ||
          row?.product?._id ||
          row?.product?.id;
        const quantity = Number(row?.quantity_added ?? row?.quantity ?? row?.quantityAdded ?? 0) || 0;
        if (productId && quantity > 0) {
          const key = String(productId);
          next[key] = quantity;
          const lineId = row?.id || row?._id || row?.basket_line_id || row?.item_id;
          if (lineId) nextLineIds[key] = String(lineId);
        }
      });

      setCartQuantities(next);
      setCartLineIds(nextLineIds);
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        setCartQuantities({});
      }
    }
  }, []);
  
 const handleAddToCart = async (product, event) => {
  event?.stopPropagation();
  const token = localStorage.getItem("token");
  if (!token || token === "null" || token === "undefined") {
    navigate("/login", { state: { from: { pathname: window.location.pathname, search: window.location.search } } });
    return;
  }
  try {
    setCartError("");
    setAddingIds((prev) => ({ ...prev, [product._id]: true }));
    const { data } = await addToCart(product._id, 1);

    if (data?.success === false) {
      throw new Error(data?.message || "Unable to add product to basket");
    }

    await loadCartQuantities();
  } catch (error) {
    console.error(error);

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      navigate("/login", { state: { from: { pathname: window.location.pathname, search: window.location.search } } });
      return;
    }

    setCartError(
      error?.response?.data?.message ||
      error?.message ||
      "Unable to add product to basket"
    );
  } finally {
    setAddingIds((prev) => ({ ...prev, [product._id]: false }));
  }
};

 const handleQuantityChange = async (product, nextQuantity, event) => {
  event?.stopPropagation();
  const token = localStorage.getItem("token");
  if (!token || token === "null" || token === "undefined") {
    navigate("/login", { state: { from: { pathname: window.location.pathname, search: window.location.search } } });
    return;
  }

  const previousQuantity = cartQuantities[product._id] || 0;
  try {
    setCartError("");
    setAddingIds((prev) => ({ ...prev, [product._id]: true }));
    setCartQuantities((prev) => ({ ...prev, [product._id]: Math.max(0, nextQuantity) }));

    const lineId = cartLineIds[product._id];
    if (!lineId) {
      await loadCartQuantities();
      throw new Error("Basket item is still syncing. Please try again.");
    }

    const { data } = await axios.put(
      `https://www.frendrops.in/api/basket/update-quantity/${encodeURIComponent(lineId)}`,
      { quantity: Math.max(0, nextQuantity) },
      { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
    );
    if (data?.success === false) {
      throw new Error(data?.message || "Unable to update basket");
    }
    await loadCartQuantities();
  } catch (error) {
    setCartQuantities((prev) => ({ ...prev, [product._id]: previousQuantity }));
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      navigate("/login", { state: { from: { pathname: window.location.pathname, search: window.location.search } } });
      return;
    }
    setCartError(error?.response?.data?.message || error?.message || "Unable to update basket");
  } finally {
    setAddingIds((prev) => ({ ...prev, [product._id]: false }));
  }
};
  useEffect(() => {
    loadProducts();
    loadCartQuantities();
  }, [searchParams, loadCartQuantities]);




  return (
    <div className="min-h-screen bg-purple-50">
      {/* Hero */}
      <UserNavbar />

      {/* Product list header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-44 pb-6">
        <div className="flex items-center gap-3 mb-5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-gray-800 shadow-sm hover:bg-gray-50"
            aria-label="Go back"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-2xl font-bold text-gray-900">{subcategoryName}</h1>
        </div>

      </div>

      {/* Products */}
     <div className="max-w-7xl mx-auto px-6 pb-20">
        {cartError && <div className="mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{cartError}</div>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 items-stretch">
            {products.map((product) => (
            <div
                key={product._id}
                onClick={() => navigate(`/product/${product._id}`)}
                className="bg-white rounded-[32px] p-5 shadow-lg hover:-translate-y-1 transition duration-300 h-full flex flex-col"
            >
                <img
                src={product.image}
                alt={product.name}
                className="w-full h-56 object-cover rounded-2xl"
                />

                <div className="mt-5 flex flex-col flex-1">
                <h3 className="font-bold text-2xl leading-tight break-words min-h-[110px] text-gray-900">
                    {product.name}
                </h3>

                <p className="text-gray-500 mt-2 text-lg">
                    {product.description || "Each packet contains 10 grams"}
                </p>

                <div className="mt-auto pt-6 flex items-center justify-between">
                    <span className="text-3xl font-bold text-purple-600">
                    ₹{product.price}
                    </span>

                    {(cartQuantities[product._id] || 0) > 0 ? (
                      <div
                        className="flex items-center overflow-hidden rounded-full bg-gradient-to-r from-purple-700 to-purple-500 text-white"
                        onClick={(event) => event.stopPropagation()}
                      >
                        <button
                          type="button"
                          className="px-4 py-3 text-xl font-bold disabled:opacity-50"
                          disabled={addingIds[product._id]}
                          onClick={(event) => handleQuantityChange(product, (cartQuantities[product._id] || 1) - 1, event)}
                        >
                          −
                        </button>
                        <span className="min-w-[36px] text-center text-lg font-bold">
                          {cartQuantities[product._id]}
                        </span>
                        <button
                          type="button"
                          className="px-4 py-3 text-xl font-bold disabled:opacity-50"
                          disabled={addingIds[product._id]}
                          onClick={(event) => handleQuantityChange(product, (cartQuantities[product._id] || 0) + 1, event)}
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <button
                        className="bg-gradient-to-r from-purple-700 to-purple-500 text-white px-7 py-3 rounded-full font-medium text-lg hover:shadow-lg transition disabled:opacity-60"
                        onClick={(event) => handleAddToCart(product, event)}
                        disabled={addingIds[product._id]}
                      >
                        {addingIds[product._id] ? "Adding..." : "Add"}
                      </button>
                    )}
                </div>
                </div>
            </div>
            ))}
        </div>
    </div>
    </div>
  );
}
